import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";
import { site } from "../../data/site";
import { useContact } from "../ContactProvider";

export default function Footer() {
  const year = new Date().getFullYear();
  const { open } = useContact();
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative pt-24 md:pt-32 pb-10 border-t border-[#262626] bg-[#050505]"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.25em] text-[#E3FF34]">
            [ Contact ]
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <button
            type="button"
            onClick={() => open()}
            data-testid="footer-email-cta"
            className="mt-6 group block w-full text-left"
          >
            <h2 className="font-['Anton'] uppercase leading-[0.86] tracking-tight text-[#F2F2F2] text-[16vw] md:text-[14vw] lg:text-[12vw]">
              Let&rsquo;s
              <br />
              <span className="inline-flex items-center gap-4">
                talk
                <ArrowUpRight
                  className="text-[#E3FF34] group-hover:rotate-12 transition-transform duration-500"
                  size={80}
                  strokeWidth={1.5}
                />
              </span>
            </h2>
          </button>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 border-t border-[#262626] pt-10">
          <div className="md:col-span-4">
            <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.25em] text-[#A3A3A3] mb-3">
              / Contact
            </p>
            <p className="font-['Outfit'] text-[#F2F2F2] text-base mb-1">
              {site.owner}
            </p>
            <a
              href={`mailto:${site.email}`}
              data-testid="footer-email-link"
              className="block font-['Outfit'] text-lg md:text-xl text-[#F2F2F2] hover:text-[#E3FF34] transition-colors break-all"
            >
              {site.email}
            </a>
            <a
              href={site.phoneHref}
              data-testid="footer-phone-link"
              className="mt-1 block font-['Outfit'] text-lg md:text-xl text-[#F2F2F2] hover:text-[#E3FF34] transition-colors"
            >
              {site.phone}
            </a>
          </div>
          <div className="md:col-span-4">
            <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.25em] text-[#A3A3A3] mb-3">
              / Social
            </p>
            <ul className="space-y-2">
              {site.socials.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="font-['Outfit'] text-lg text-[#F2F2F2] hover:text-[#E3FF34] transition-colors inline-flex items-center gap-2"
                  >
                    {s.label}
                    <ArrowUpRight size={14} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.25em] text-[#A3A3A3] mb-3">
              / Studio
            </p>
            <p className="font-['Outfit'] text-[#F2F2F2] text-lg">
              {site.location}
              <span className="text-[#7C3AED]"> → </span>
              {site.scope}.
              <br />
              <span className="text-[#A3A3A3] text-base">
                Independent. Senior-only. Built sustainably.
              </span>
            </p>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#262626] flex flex-col md:flex-row gap-4 md:items-center md:justify-between font-['JetBrains_Mono'] text-[10px] uppercase tracking-[0.25em] text-[#A3A3A3]">
          <span>© {year} {site.brand}. All rights reserved.</span>
          <span className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-[#E3FF34] inline-block animate-pulse" />
            Currently accepting Q1 retainers
          </span>
        </div>
      </div>
    </footer>
  );
}
